<template>
  <div>
    <el-upload
      :action="actionUrl"
      drag
      list-type="picture-card"
      accept=".jpg,.jpeg,.png,.gif"
      :on-success="handleSuccess"
      :before-upload="getbef"
      v-loading="loading"
      :file-list="fileLists"
      :multiple="multble"
      :on-change="handleChange"
      :class="{ hide: hideUploadEdit }"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <el-image
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          fit="contain"
        ></el-image>
        <span class="el-upload-list__item-actions">
          <span
            v-if="multble"
            class="el-upload-list__item-preview"
            @click="getjian(file, 1)"
          >
            <i class="el-icon-caret-left"></i>
          </span>
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
          <span
            v-if="multble"
            class="el-upload-list__item-delete"
            @click="getjian(file, 2)"
          >
            <i class="el-icon-caret-right"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import ty from "../../utils/ty";
export default {
  name: "VploadImgTwo",
  props: {
    limit: {
      type: Number,
      default: 12,
    },
    action: {
      type: String,
      default: ty.apiurl + "/common/uploadFileUrl",
    },
    type: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    multble: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      actionUrl: this.action + "?fileType=0&type=" + this.type,
      hideUploadEdit: this.fileList.length >= this.limit,
      fileLists: this.fileList,
      editForm: {
        url: "",
        uid: null,
      },
      editView: false,
      loading: false,
    };
  },
  watch: {
    fileList(n, o) {
      //n为新值,o为旧值;
      console.log("4444", n, o);
      this.fileLists = n;
      this.hideUploadEdit = this.fileList.length >= this.limit;
    },
  },
  methods: {
    getbef() {
      this.loading = true;
    },
    // 移除图片
    handleRemove(file) {
      for (let i in this.fileLists) {
        if (this.fileLists[i].uid == file.uid) {
          this.fileLists.splice(i, 1);
        }
      }
      this.hideUploadEdit = this.fileLists.length >= 1;
      this.submitFile(file.url, 0);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange(file, fileList) {
      this.hideUploadEdit = fileList.length >= 1;
      console.log("888");
    },
    handleSuccess(response, file, fileList) {
      var that = this;
      setTimeout(function () {
        that.submitFile(response, 1, fileList);
      }, 300);
      console.log("6666");
    },
    getjian(e, d) {
      var that = this;
      that.$emit("getadd", e, d);
    },
    // 将图片文件传回给父组件
    submitFile(filePath, add, list) {
      //add:0是删除。1是新增
      var that = this;
      if (add == 1) {
        console.log("444", list);
        var obj = {
          status: "success",
          uid: "",
          url: filePath.msg,
        };
        that.fileLists = list;
        that.$emit("submitImg", filePath.msg, add);
        that.loading = false;
      } else {
        that.$emit("submitImg", filePath, add);
        that.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.el-icon-plus {
  font-size: 30px !important;
}

.el-icon-zoom-in {
  font-size: 18px !important;
}

.el-icon-delete {
  font-size: 18px !important;
  color: rgb(243, 143, 130);
}

.el-input >>> .el-textarea__inner {
  font-size: 18px !important;
}

.hide >>> .el-upload--picture-card {
  display: none;
}
:deep .el-upload-dragger {
  width: 148px !important;
  height: 148px;
}
</style>
